import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import OnSellsTab from './TabOnSells';
import MintedTab from './MintedTab';
import ArtistsTab from './TabArtists';
import SettingsTab from './TabSettings';
import { toast } from 'react-toastify';
import ImageViewerDialog from '../Dialog/DialogImageViewer';
import { Alert, AlertTitle } from '@material-ui/lab';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import CloseIcon from '@material-ui/icons/Close';
import { firebaseFireStore } from '../../config/firebaseFirestore';
import {
  doc,
  getDoc,
  getDocs,
  writeBatch,
  query,
  collection,
  where,
} from 'firebase/firestore/lite';
import { bucketlink1 } from '../../config/fire-conf';
// import ShowMoreText from 'react-show-more-text';

export default function SellerContainer(props) {
  const userDataRedux = useSelector((state) => state.authReducer.userData);
  const userDataLoadingRedux = useSelector(
    (state) => state.authReducer.userLoading,
  );
  const router = useRouter();
  const [sellerProfile, setsellerProfile] = useState(null);
  const [value, setValue] = useState(0);
  const [imageHash, setimageHash] = useState(Date.now());
  const [newSeller, setnewSeller] = useState(false);
  const [imageViewerDialogState, setimageViewerDialogState] = useState(false);
  const [alertState, setalertState] = useState(true);
  const [isSellerMentor, setisSellerMentor] = useState(false);
  const [collectorUrl, setcollectorUrl] = useState('');
  const [collectorName, setcollectorName] = useState('');
  const [collectorBio, setcollectorBio] = useState('');
  const [showmore, setshowmore] = useState(false);

  const { collectorId, tab } = router.query;

  useEffect(() => {
    setcollectorUrl(`${window.location.origin}/collector/${collectorId}`);
  }, []);

  useEffect(() => {
    if (collectorId && !userDataLoadingRedux) {
      isSellerMinterFunc();
    }
  }, [collectorId, userDataLoadingRedux, userDataRedux]);

  useEffect(() => {
    if (props.collectorName) {
      setcollectorName(props.collectorName);
    } else {
      setcollectorName('unknown');
    }
  }, [props.collectorName]);

  useEffect(() => {
    if (props.collectorData) {
      getSellerData();
    }
  }, [props.collectorData]);

  useEffect(() => {
    if (tab === 'Settings') {
      setValue(3);
    }
  }, [tab]);

  useEffect(() => {
    if (sellerProfile) {
      setimageHash(Date.now());
    }
  }, [sellerProfile]);

  const isSellerMinterFunc = async () => {
    const docRef = doc(firebaseFireStore, 'musicartMinters', collectorId);

    let dbRef = await getDoc(docRef);

    if (dbRef.data()) {
      setisSellerMentor(true);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const adminCheck = async () => {
    const q = query(
      collection(firebaseFireStore, 'admin'),
      where('admins', 'array-contains-any', [userDataRedux.uid]),
    );

    let dbRef = await getDocs(q);

    if (!dbRef.empty) {
      return true;
    } else {
      return false;
    }
  };

  const getSellerData = async () => {
    //get sellerdata
    if (props.collectorData) {
      let dataObj = { ...props.collectorData };

      let showSellerPage = false;
      console.log('1111', dataObj, dataObj && dataObj.adminState === 'ACCEPT');

      if (dataObj && dataObj.adminState === 'ACCEPT') {
        showSellerPage = true;
      } else {
        console.log('Reject/pending state');
        if (
          userDataRedux &&
          userDataRedux.uid &&
          collectorId &&
          userDataRedux.uid === collectorId
        ) {
          console.log('owner of creator');

          showSellerPage = true;
        } else if (userDataRedux && userDataRedux.uid) {
          console.log('admin check');
          let check = await adminCheck();
          if (check) {
            console.log('admin pass');
            showSellerPage = true;
          }
        }
      }

      console.log('showSellerPage', showSellerPage);
      if (showSellerPage) {
        if (dataObj.bio) {
          setcollectorBio(dataObj.bio);
        }
        setsellerProfile({ ...dataObj });
      } else {
        router.push('/');
      }
    } else if (userDataRedux && collectorId === userDataRedux.uid) {
      setnewSeller(true);
    } else {
      router.push('/');
    }
  };

  const reappeal = async () => {
    try {
      let batch = writeBatch(firebaseFireStore);

      let tokenSummaryRef = doc(
        firebaseFireStore,
        'musicartSellers',
        collectorId,
      );

      batch.update(tokenSummaryRef, {
        adminState: 'PENDING',
      });

      batch.commit();

      toast.success('Reappealed successfully!', {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });
      setalertState(false);
    } catch (err) {
      // console.log("err", err);
    }
  };

  return (
    <>
      <main className="main">
        <section className="relative block h-300-px">
          <div
            className="absolute top-0 w-full h-full bg-center bg-cover"
            style={{
              backgroundImage:
                sellerProfile && sellerProfile.thumbnailImage
                  ? `url(${
                      sellerProfile.thumbnailImage.includes(
                        '_1920x1920?alt=media',
                      )
                        ? sellerProfile.thumbnailImage
                        : sellerProfile.thumbnailImage +
                          '_1920x1920?alt=media&t=' +
                          imageHash
                    })`
                  : 'linear-gradient(90deg, rgba(252,213,10,1) 0%, rgba(241,102,4,1) 100%)',

              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          ></div>
        </section>
        <div className="center_container">
          <div className="container">
            <div className="row row--grid">
              <div className="w-full discover-screen-artist1 xl:w-3/12 lg:w-4/12 md:w-6/12">
                <div className="author author--page">
                  <div className="author__meta">
                    <div
                      className={
                        isSellerMentor
                          ? 'author__avatar author__avatar--verified'
                          : 'author__avatar'
                      }
                      style={{ backgroundColor: '#ff9700' }}
                      onClick={() => setimageViewerDialogState(true)}
                    >
                      <img
                        alt="profile-image"
                        className="cursor-pointer"
                        src={
                          // sellerProfile?.oneTimeProfileUrl
                          //   ? sellerProfile.oneTimeProfileUrl
                          //   :
                          sellerProfile?.photoUrl
                            ? `${sellerProfile.photoUrl}_250x250?alt=media`
                            : '/img/avatars/avatar.jpg'
                        }
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = '/img/avatars/avatar.jpg';
                        }}
                      />
                    </div>
                    {sellerProfile && collectorName && (
                      <h1
                        className="author__name"
                        style={{
                          width: '95%',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          padding: '0px 1px',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {collectorName && <>@{collectorName}</>}
                      </h1>
                    )}
                    {collectorBio && (
                      <span>
                        <span style={{ wordBreak: 'break-all' }}>
                          {collectorBio.length > 110 && !showmore
                            ? collectorBio.slice(0, 110) + '... '
                            : collectorBio}
                          {collectorBio.length > 110 && (
                            <button
                              className="link ml-1"
                              onClick={() => setshowmore(!showmore)}
                            >
                              Show {showmore ? 'less' : 'more'}
                            </button>
                          )}
                        </span>
                      </span>
                    )}
                    <div className="author__code">
                      <p className="author__code_truncate">
                        {collectorUrl.length > 28
                          ? collectorUrl.substring(0, 28) + '...'
                          : collectorUrl}
                      </p>
                      <div>
                        <CopyToClipboard
                          text={collectorUrl}
                          onCopy={() => {
                            toast.success('URL copied.', {
                              position: 'bottom-left',
                              autoClose: 10000,
                              hideProgressBar: false,
                              closeOnClick: true,
                              pauseOnHover: true,
                              draggable: true,
                              zIndex: 2147483641,
                              toastId: 'collectorprofile',
                            });
                          }}
                        >
                          <button type="button">
                            <span>Copied</span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                            >
                              <path d="M18,19H6a3,3,0,0,1-3-3V8A1,1,0,0,0,1,8v8a5,5,0,0,0,5,5H18a1,1,0,0,0,0-2Zm5-9.06a1.31,1.31,0,0,0-.06-.27l0-.09a1.07,1.07,0,0,0-.19-.28h0l-6-6h0a1.07,1.07,0,0,0-.28-.19l-.09,0L16.06,3H8A3,3,0,0,0,5,6v8a3,3,0,0,0,3,3H20a3,3,0,0,0,3-3V10S23,10,23,9.94ZM17,6.41,19.59,9H18a1,1,0,0,1-1-1ZM21,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V6A1,1,0,0,1,8,5h7V8a3,3,0,0,0,3,3h3Z" />
                            </svg>
                          </button>
                        </CopyToClipboard>
                      </div>
                    </div>

                    <div className="author__social">
                      {sellerProfile && sellerProfile.twitter && (
                        <a
                          href={sellerProfile && sellerProfile.twitter}
                          target="_self"
                          rel="noreferrer"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M22,5.8a8.49,8.49,0,0,1-2.36.64,4.13,4.13,0,0,0,1.81-2.27,8.21,8.21,0,0,1-2.61,1,4.1,4.1,0,0,0-7,3.74A11.64,11.64,0,0,1,3.39,4.62a4.16,4.16,0,0,0-.55,2.07A4.09,4.09,0,0,0,4.66,10.1,4.05,4.05,0,0,1,2.8,9.59v.05a4.1,4.1,0,0,0,3.3,4A3.93,3.93,0,0,1,5,13.81a4.9,4.9,0,0,1-.77-.07,4.11,4.11,0,0,0,3.83,2.84A8.22,8.22,0,0,1,3,18.34a7.93,7.93,0,0,1-1-.06,11.57,11.57,0,0,0,6.29,1.85A11.59,11.59,0,0,0,20,8.45c0-.17,0-.35,0-.53A8.43,8.43,0,0,0,22,5.8Z" />
                          </svg>
                        </a>
                      )}
                      {sellerProfile && sellerProfile.medium && (
                        <a
                          href={sellerProfile && sellerProfile.medium}
                          target="_self"
                          rel="noreferrer"
                        >
                          <svg
                            viewBox="0 0 48 48"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M38.0766847,15.8542954 C36.0693906,15.7935177 34.2504839,14.8341149 32.8791434,13.5466056 C32.1316475,12.8317108 31.540171,11.9694126 31.1415066,11.0151329 C30.7426093,10.0603874 30.5453728,9.03391952 30.5619062,8 L24.9731521,8 L24.9731521,28.8295196 C24.9731521,32.3434487 22.8773693,34.4182737 20.2765028,34.4182737 C19.6505623,34.4320127 19.0283477,34.3209362 18.4461858,34.0908659 C17.8640239,33.8612612 17.3337909,33.5175528 16.8862248,33.0797671 C16.4386588,32.6422142 16.0833071,32.1196657 15.8404292,31.5426268 C15.5977841,30.9658208 15.4727358,30.3459348 15.4727358,29.7202272 C15.4727358,29.0940539 15.5977841,28.4746337 15.8404292,27.8978277 C16.0833071,27.3207888 16.4386588,26.7980074 16.8862248,26.3604545 C17.3337909,25.9229017 17.8640239,25.5791933 18.4461858,25.3491229 C19.0283477,25.1192854 19.6505623,25.0084418 20.2765028,25.0219479 C20.7939283,25.0263724 21.3069293,25.1167239 21.794781,25.2902081 L21.794781,19.5985278 C21.2957518,19.4900128 20.7869423,19.436221 20.2765028,19.4380839 C18.2431278,19.4392483 16.2560928,20.0426009 14.5659604,21.1729264 C12.875828,22.303019 11.5587449,23.9090873 10.7814424,25.7878401 C10.003907,27.666593 9.80084889,29.7339663 10.1981162,31.7275214 C10.5953834,33.7217752 11.5748126,35.5530237 13.0129853,36.9904978 C14.4509252,38.4277391 16.2828722,39.4064696 18.277126,39.8028054 C20.2711469,40.1991413 22.3382874,39.9951517 24.2163416,39.2169177 C26.0948616,38.4384508 27.7002312,37.1209021 28.8296253,35.4300711 C29.9592522,33.7397058 30.5619062,31.7522051 30.5619062,29.7188301 L30.5619062,18.8324027 C32.7275484,20.3418321 35.3149087,21.0404263 38.0766847,21.0867664 L38.0766847,15.8542954 Z"></path>
                          </svg>
                        </a>
                      )}
                      {sellerProfile && sellerProfile.facebook && (
                        <a
                          href={sellerProfile && sellerProfile.facebook}
                          target="_self"
                          rel="noreferrer"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                          </svg>
                        </a>
                      )}
                      {sellerProfile && sellerProfile.instagram && (
                        <a
                          href={sellerProfile && sellerProfile.instagram}
                          target="_self"
                          rel="noreferrer"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M17.34,5.46h0a1.2,1.2,0,1,0,1.2,1.2A1.2,1.2,0,0,0,17.34,5.46Zm4.6,2.42a7.59,7.59,0,0,0-.46-2.43,4.94,4.94,0,0,0-1.16-1.77,4.7,4.7,0,0,0-1.77-1.15,7.3,7.3,0,0,0-2.43-.47C15.06,2,14.72,2,12,2s-3.06,0-4.12.06a7.3,7.3,0,0,0-2.43.47A4.78,4.78,0,0,0,3.68,3.68,4.7,4.7,0,0,0,2.53,5.45a7.3,7.3,0,0,0-.47,2.43C2,8.94,2,9.28,2,12s0,3.06.06,4.12a7.3,7.3,0,0,0,.47,2.43,4.7,4.7,0,0,0,1.15,1.77,4.78,4.78,0,0,0,1.77,1.15,7.3,7.3,0,0,0,2.43.47C8.94,22,9.28,22,12,22s3.06,0,4.12-.06a7.3,7.3,0,0,0,2.43-.47,4.7,4.7,0,0,0,1.77-1.15,4.85,4.85,0,0,0,1.16-1.77,7.59,7.59,0,0,0,.46-2.43c0-1.06.06-1.4.06-4.12S22,8.94,21.94,7.88ZM20.14,16a5.61,5.61,0,0,1-.34,1.86,3.06,3.06,0,0,1-.75,1.15,3.19,3.19,0,0,1-1.15.75,5.61,5.61,0,0,1-1.86.34c-1,.05-1.37.06-4,.06s-3,0-4-.06A5.73,5.73,0,0,1,6.1,19.8,3.27,3.27,0,0,1,5,19.05a3,3,0,0,1-.74-1.15A5.54,5.54,0,0,1,3.86,16c0-1-.06-1.37-.06-4s0-3,.06-4A5.54,5.54,0,0,1,4.21,6.1,3,3,0,0,1,5,5,3.14,3.14,0,0,1,6.1,4.2,5.73,5.73,0,0,1,8,3.86c1,0,1.37-.06,4-.06s3,0,4,.06a5.61,5.61,0,0,1,1.86.34A3.06,3.06,0,0,1,19.05,5,3.06,3.06,0,0,1,19.8,6.1,5.61,5.61,0,0,1,20.14,8c.05,1,.06,1.37.06,4S20.19,15,20.14,16ZM12,6.87A5.13,5.13,0,1,0,17.14,12,5.12,5.12,0,0,0,12,6.87Zm0,8.46A3.33,3.33,0,1,1,15.33,12,3.33,3.33,0,0,1,12,15.33Z" />
                          </svg>
                        </a>
                      )}
                    </div>
                    <div className="author__wrap"></div>
                  </div>
                </div>
              </div>

              <div className="w-full xl:w-9/12 discover-screen-artist2 lg:w-8/12 md:w-6/12">
                <div className="p-gutter">
                  {(() => {
                    if (
                      sellerProfile &&
                      userDataRedux &&
                      userDataRedux.uid &&
                      userDataRedux.uid === collectorId &&
                      (!sellerProfile.adminState ||
                        (sellerProfile.adminState &&
                          (sellerProfile.adminState === 'PENDING' ||
                            sellerProfile.adminState === 'REJECT')))
                    ) {
                      return (
                        <Collapse in={alertState}>
                          <div
                            style={{
                              margin: '25px auto 10px auto',
                            }}
                            className="alert-old-tran"
                          >
                            <Alert
                              severity={
                                sellerProfile.adminState === 'PENDING'
                                  ? 'info'
                                  : 'error'
                              }
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setalertState(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              <AlertTitle>
                                {sellerProfile.adminState === 'PENDING' ? (
                                  'Your profile is in pending state!'
                                ) : (
                                  <>
                                    Your profile is rejected by MusicArt Team.
                                  </>
                                )}
                              </AlertTitle>
                              {sellerProfile.adminState === 'PENDING' ? (
                                'MusicArt Team will got through your details and notify you.'
                              ) : (
                                <>
                                  Rejection reason:{' '}
                                  {sellerProfile.rejectionReason
                                    ? sellerProfile.rejectionReason
                                    : 'not provided'}
                                  <br />
                                  Please update your details and reapply -{' '}
                                  <strong
                                    className="cursor-pointer reappeal_btn"
                                    onClick={reappeal}
                                  >
                                    Reappeal
                                  </strong>
                                </>
                              )}
                            </Alert>
                          </div>
                        </Collapse>
                      );
                    } else if (
                      sellerProfile &&
                      (!sellerProfile.adminState ||
                        (sellerProfile.adminState &&
                          (sellerProfile.adminState === 'PENDING' ||
                            sellerProfile.adminState === 'REJECT')))
                    ) {
                      return (
                        <Collapse in={alertState}>
                          <div
                            style={{
                              margin: '25px auto 10px auto',
                            }}
                            className="alert-old-tran"
                          >
                            <Alert
                              severity={
                                sellerProfile.adminState === 'PENDING'
                                  ? 'info'
                                  : 'error'
                              }
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setalertState(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              <AlertTitle>
                                {sellerProfile.adminState === 'PENDING' ? (
                                  'This profile is in pending state!'
                                ) : (
                                  <>This profile has been rejected!</>
                                )}
                              </AlertTitle>
                            </Alert>
                          </div>
                        </Collapse>
                      );
                    }
                  })()}

                  <div className="profile">
                    <AntTabs
                      value={value}
                      onChange={handleChange}
                      aria-label="ant example"
                      variant="scrollable"
                      scrollButtons="auto"
                    >
                      <AntTab label="On Sale" />
                      <AntTab label="Minted" />
                      {userDataRedux && userDataRedux.uid === collectorId && (
                        <AntTab label="MusicArtists" />
                      )}
                      {userDataRedux && userDataRedux.uid === collectorId && (
                        <AntTab label="Settings" />
                      )}
                    </AntTabs>
                  </div>
                </div>
                <div
                  className="bg-white flex-auto"
                  style={{ marginBottom: 50 }}
                >
                  <TabPanel value={value} index={0}>
                    <OnSellsTab collectorId={collectorId} />
                  </TabPanel>
                  <TabPanel value={value} index={1}>
                    <MintedTab collectorId={collectorId} />
                  </TabPanel>
                  {userDataRedux && userDataRedux.uid === collectorId && (
                    <>
                      <TabPanel value={value} index={2}>
                        <ArtistsTab collectorId={collectorId} />
                      </TabPanel>
                      <TabPanel value={value} index={3}>
                        <SettingsTab
                          collectorId={collectorId}
                          sellerProfile={sellerProfile}
                          setsellerProfile={setsellerProfile}
                          newSeller={newSeller}
                          setnewSeller={setnewSeller}
                          setimageHash={setimageHash}
                        />
                      </TabPanel>
                    </>
                  )}
                </div>
                <div className="tab-content">
                  <div
                    className="tab-pane fade show active"
                    id="tab-1"
                    role="tabpanel"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <ImageViewerDialog
        dialogState={imageViewerDialogState}
        setdialogState={setimageViewerDialogState}
        imageUrl={
          collectorId
            ? `${
                collectorId &&
                bucketlink1 +
                  'profile_images%2F' +
                  collectorId +
                  '_250x250?alt=media'
              }`
            : '/img/unknow.jpg'
        }
      />
    </>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  const userDataRedux = useSelector((state) => state.authReducer.userData);

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

const AntTabs = withStyles({
  root: {
    borderBottom: '1px solid #e8e8e8',
  },
  indicator: {
    backgroundColor: '#1890ff',
  },
})(Tabs);

const AntTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(4),
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      color: '#40a9ff',
      opacity: 1,
    },
    '&$selected': {
      color: '#1890ff',
      fontWeight: theme.typography.fontWeightMedium,
    },
    '&:focus': {
      color: '#40a9ff',
      outline: 'none',
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  padding: {
    padding: theme.spacing(3),
  },
}));
